import React from 'react';
import SlidingPane from "react-sliding-pane";
import ClipLoader from "react-spinners/ClipLoader";

export const SharedSlidingPane = ({ 
    isOpen, 
    title, 
    onClose, 
    width = "750px",
    from = "right",
    loading = false,
    children 
}) => {
    // Função para determinar a largura do painel com base no tamanho da tela
    const getResponsiveWidth = () => {
        if (window.innerWidth < 576) {
            return '100%';
        } else if (window.innerWidth < 992) {
            return typeof width === 'string' && width.includes('%') ? width : '85%';
        } else {
            return width;
        }
    };

    return (
        <SlidingPane
            className="custom-sliding-pane"
            overlayClassName="custom-sliding-overlay"
            isOpen={isOpen}
            title={title}
            width={getResponsiveWidth()}
            from={from}
            onRequestClose={onClose}
            zIndex={1051}
        >
            <div className={`sliding-content ${window.innerWidth < 576 ? 'p-2' : 'p-4'}`}>
                {loading ? (
                    <center>
                        <ClipLoader color={'#000'} loading={true} />
                    </center>
                ) : (
                    children
                )}
            </div>
            <style jsx="true">{`
                .custom-sliding-pane {
                    z-index: 1051 !important;
                }
                
                .custom-sliding-overlay {
                    z-index: 1050 !important;
                }

                @media (max-width: 576px) {
                    .slide-pane__header {
                        padding: 12px 16px;
                    }
                    
                    .slide-pane__title {
                        font-size: 1.1rem;
                    }
                    
                    .slide-pane__content {
                        padding: 0 !important;
                    }
                    
                    .sliding-content {
                        padding: 0.75rem !important;
                    }
                    
                    .slide-pane__header h2 {
                        font-size: 18px;
                    }
                }
            `}</style>
        </SlidingPane>
    );
};